import { render } from "./ErrorLicenseAdminNoLicense.vue?vue&type=template&id=4b423350&scoped=true"
import script from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js"
export * from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js"

import "./ErrorLicenseAdminNoLicense.vue?vue&type=style&index=0&id=4b423350&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b423350"]])

export default __exports__